<template>
  <div class="contenedor-cpanel">
    <section class="contenedor-c">
      <div class="contenedor-titulo">
        <h1>Crear Entrega de Venta</h1>
        <div class="barra"></div>
      </div>
      <div class="contenedor_info_no_entregados">
        <router-link :to="`/listar-ventas-no-entregadas`" class="boton_volver_login"><span>&#8592;</span> Atrás</router-link>
        <p><b>Nombre y Apellido:</b> {{ this.venta.nombre }} {{ this.venta.apellido }}</p>
        <p><b>Email:</b> {{ this.venta.email }} </p>
        <p><b>Celular:</b> {{ this.venta.celular }} </p>
        <p><b>Monto:</b> ${{ dotsCadaTres(parseFloat(this.venta.precio_total).toFixed(2).replace(/\.00$/, '')) }}</p>
      </div>
      <ul class="puntos_entrega_productos_lista">
        <ProductosVendidosListaItem
          v-for="item in venta.productos"
          :item="item"
          :key="item.producto_id"
        ></ProductosVendidosListaItem>
      </ul>
    </section>
  </div>
</template>

<script>
import ProductosVendidosListaItem from '../components/ProductosVendidosListaItem.vue'
import ventasService from '../services/ventas'
import entregasService from '../services/entregas'
export default {
  name: 'CrearEntregaVenta',
  components: {
    ProductosVendidosListaItem
  },
  data: function () {
    return {
      venta: [],
      socios: [],
      formasDeEntrega: [],
      cargando: false,
      pedido: {
        punto_de_entrega_id: null,
        fecha_de_entrega: null,
        forma_de_entrega_id: null,
        venta_id: this.$route.params.id,
        descripcion: null
      },
      errores: {
        forma_de_entrega_id: null,
        punto_de_entrega_id: null,
        fecha_de_entrega: null
      }
    }
  },
  methods: {
    dotsCadaTres (dni) {
      const number = dni.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
      return number
    },
    crearEntrega (pedido) {
      console.log('qqqq')
      console.log(pedido)
      if (this.cargando) {
        return null
      }
      this.errores = {
        forma_de_entrega_id: null,
        punto_de_entrega_id: null,
        fecha_de_entrega: null
      }
      this.cargando = true
      ventasService
        .crearEntrega(pedido)
        .then(respuesta => {
          this.cargando = false
          if (respuesta.success) {
            this.socio = {
              persona_id: null
            }
            this.errores = {
              forma_de_entrega_id: null,
              punto_de_entrega_id: null,
              fecha_de_entrega: null
            }
            this.$router.push('/listar-ventas-no-entregadas')
          } else {
            this.errores = {
              forma_de_entrega_id: null,
              punto_de_entrega_id: null,
              fecha_de_entrega: null,
              ...respuesta.errors
            }
          }
        })
    }
  },
  mounted: function () {
    ventasService
      .traerPosiblesPuntosDeEntregaParaVenta(this.$route.params.id)
      .then(respuesta => {
        // this.cargando = false
        this.socios = respuesta
        console.log('Punto de Entrega:', respuesta)
        this.socios.map(function (x) {
          // const pepe = x.nombre + ' ' + x.apellido
          // console.log(pepe)
          x.item_data = x.nombre + ' ' + x.apellido
          // return x.item_data = pepe
        })
      })
    ventasService
      .traerVentaPorId(this.$route.params.id)
      .then(respuesta => {
        this.venta = respuesta.data
        console.log('VentaPorId:', respuesta.data)
      })
    entregasService
      .traerFormasDeEntrega()
      .then(respuesta => {
        // this.cargando = false
        this.formasDeEntrega = respuesta
      })
  }
}
</script>

<style>

</style>
